import preact, { Component, h } from 'preact'
import Panel from '../panel'
import ButtonControl from '../button-control'
import InputGroup from '../ui-components/InputGroup'

interface Link {
  title: string,
  url: string
}

interface Props {
  links: Array<Link>
  onTitleChanged: (title: string) => void,
  onAddLink: (title: string, url: string) => void,
  onLinkChanged: (idx: number, title: string, url: string) => void,
  onRemoveLink: (idx: number) => void,
  footerTitle: string
}

interface State {
  title: string,
  url: string
}

class FooterPanel extends Component<Props, State> {
  constructor (props: Props) {
    super()
    this.state = {
      title: '',
      url: ''
    }
  }

  render (
    { links, onAddLink, onRemoveLink, footerTitle, onTitleChanged, onLinkChanged }: Props,
    { title, url } : State
  ) {

    return (
    <Panel title='Footer' class='footer_footer-panel'>
      <label className='trigger-label'>Applicable for embeddable widget only. Footer will be shown on the home and topic pages of the embeddable widget.</label>
        <InputGroup
          title='Title'
          type='text'
          qaClasses='footer_footer-title'
          onChange={(e: { target: HTMLInputElement }) => {
            onTitleChanged(e.target.value)
          }}              
          value={footerTitle} />
          <div className='footer_labels-wrapper'>
            <label>External link text</label>
            <label>External link URL</label>
          </div>
          { links.map((link: Link, idx: number) => {
              return <div className='footer_wrapper-inputs'>
                <input
                  type='text'
                  class='footer_footer-inputs'
                  onChange = {(e: preact.ChangeEvent<HTMLSelectElement>) => {
                    onLinkChanged(idx, e.target.value, link.url)
                  }}              
                  value={link.title} />
                <input
                  type='text'
                  class='footer_footer-inputs long'
                  onChange = {(e: preact.ChangeEvent<HTMLSelectElement>) => {
                    onLinkChanged(idx, link.title, e.target.value)
                  }}              
                  value={link.url} />
                <ButtonControl 
                  title='Remove' 
                  onClick={() => onRemoveLink(idx)} 
                  variant='warning' 
                  class='footer_add-more-links-button'/>
              </div>
          }) }
          <div className='footer_wrapper-inputs'>
            <input
              type='text'
              placeholder='Add link text'
              class='footer_footer-inputs'
              onChange = {(e: preact.ChangeEvent<HTMLSelectElement>) => {
                this.setState({ title: e.target.value })
              }}            
              value={title} />
            <input
              type='text'
              placeholder='Add link URL'
              class='footer_footer-inputs long'
              onChange = {(e: preact.ChangeEvent<HTMLSelectElement>) => {
                this.setState({ url: e.target.value })
              }}              
              value={url} />
            <ButtonControl 
              title='Add' 
              onClick={() => {
                onAddLink(this.state.title, this.state.url)
                this.setState({ title: '', url: '' })
              }} 
              variant='primary' 
              class='footer_add-more-links-button'/>
          </div>
    </Panel>
    )
  }
}
export { FooterPanel, Link }
